export default "__VITE_ASSET__375929ad__"